import { useEffect } from 'react';

export function Toast({ text, tone = 'ok', onDone }: {
  text: string; tone?: 'ok' | 'bad'; onDone: () => void;
}) {
  useEffect(() => {
    const id = setTimeout(onDone, 2600);
    return () => clearTimeout(id);
  }, [onDone]);
  return (
    <div className="pointer-events-none fixed inset-x-4 bottom-24 z-50 flex justify-center">
      <div className={`rise max-w-sm rounded-xl border px-4 py-2.5 text-center text-sm font-semibold shadow-lift
        ${tone === 'ok' ? 'border-turq/40 bg-raised text-chalk' : 'border-alarm/50 bg-raised text-alarm'}`}>
        {text}
      </div>
    </div>
  );
}
